import { render, staticRenderFns } from "./QCReport.vue?vue&type=template&id=24a8094c&scoped=true"
import script from "./QCReport.vue?vue&type=script&lang=js"
export * from "./QCReport.vue?vue&type=script&lang=js"
import style0 from "./QCReport.vue?vue&type=style&index=0&id=24a8094c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a8094c",
  null
  
)

export default component.exports